import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  currentDate:any= new Date(); // Initialize currentDate with the current date
  isPrivacyAgreed: boolean = false; 
  constructor(public dialogRef: MatDialogRef<PrivacyPolicyComponent>, private cdr: ChangeDetectorRef) { }
  ngOnInit(): void {
    // const today = new Date();
    // this.currentDate = today.toLocaleDateString();
    // console.log(this.currentDate) 
    // this.cdr.detectChanges();
  }
  closePopup(){
    this.dialogRef.close();
    this.isPrivacyAgreed = true; 
    sessionStorage.setItem('isPrivacyAgreed', JSON.stringify(this.isPrivacyAgreed)); 
  }
}
